
const m = window.require("@ember/array/mutable");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
